<template>
  <div>
    <h1>Soluti Certificação Digital</h1>

    <div class="texto">
      <p>
        Informações sobre nossos produtos, serviços, atendimento e suporte técnico estão disponíveis no nosso site:
        <a href="http://www.soluti.com.br/">www.soluti.com.br</a>
      </p>
      <br/>
      <p>
        Neste site estão informações a respeito da AC El Salvador, Autoridade Certificadora, e a respeito de suas AC's
        subordinadas e das AC's que utilizam a AC El Salvador como PSS.
      </p>
      <br/><br/>
    </div>

    <ul class="lista-downloads">
      <li class="prod">Autoridades Certificadoras de 1&ordm; Nível</li>

      <li v-for="(item,ref) in acs" v-if="item.nivel == 1">
        <a @click="mudarAC(item._key)">AC {{item.nome}}</a>
        <span>Repositório da Autoridade Certificadora {{item.nome}}</span>
      </li>
    </ul>

    <ul class="lista-downloads">
      <li class="prod">Autoridades Certificadoras de 2&ordm; Nível</li>
      <li v-for="(item,ref) in acs" v-if="item.nivel == 2">
        <a @click="mudarAC(item._key)">AC {{item.nome}}</a>
        <span>Repositório da Autoridade Certificadora {{item.nome}}</span>
      </li>
    </ul>

    <ul class="lista-downloads">
      <li class="prod">Arquivo da LCR</li>
      <li>
        <a href="/lcr/arquivo/">Lista de Certificados Revogados</a>
        <span>Repositório com todas as LCRs emitidas</span>
      </li>
    </ul>

    <ul class="lista-downloads">
      <br><br>
      <li class="prod">Disponibilidade do Repositório</li>
      <img src="https://share.pingdom.com/banners/6ba0566a" alt="Uptime Report" />
    </ul>
  </div>
</template>

<script>
import { EventBus } from '../main';

export default {
  computed: {
    acs() {
      //console.log('Computed: Home acs');
      /**
        Preparar Array com as ACs para o v-for
      */
      const resultArray = [];
      for( let key in EventBus.acs ) {
        const item = EventBus.acs[key];
        item._key = key;
        resultArray.push( item );
      }
      return resultArray;
    }
  },
  methods: {
    mudarAC( selecao, nivel ) {
      EventBus.$emit('mudarAC', selecao );
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Home.vue?f16cebda